<template>
  <div :class="$style.container">
    <h2 v-if="config.title" :class="$style.title">
      {{ config.title }}
    </h2>
    <div :class="$style.slider">
      <Slider1XP has-multiple-slides-per-view has-zoom>
        <figure v-for="(product, index) in config.products" :key="index" :class="$style.figure">
          <a
            :href="product.primaryLink"
            :navigationID="product.navigationID"
            :navigationType="product.navigationType"
            target="_self"
          >
            <img :alt="product.title" :src="product.imageBig || product.image" />
          </a>
          <figcaption>
            <div
              v-if="product.isBestseller || checkIsNew(product.isNew, product.publicationDate)"
              :class="$style.badgeContainer"
            >
              <Badge
                v-for="badge in [
                  ...(checkIsNew(product.isNew, product.publicationDate) ? [newText || 'New'] : []),
                  ...(product.isBestseller ? [bestsellerText || 'Bestseller'] : []),
                ]"
                :key="badge"
                color="blue"
                :text="badge"
              />
            </div>
            <a
              :class="$style.primaryLink"
              :href="product.primaryLink"
              :navigationID="product.navigationID"
              :navigationType="product.navigationType"
              target="_self"
            >
              <div v-if="!config.isShop" :class="$style.productTyp">{{ product.type }}</div>
              <p v-if="!config.isShop" :class="$style.productTitle" v-html="product.title" />
              <p v-if="config.isShop" :class="$style.productTitle" v-html="product.title" />
              <div v-if="config.isShop" :class="$style.productTyp">{{ product.type }}</div>
              <div :class="$style.productText" v-html="product.text" />
              <span v-if="config.isShop" :class="$style.shopPrice">
                <div :class="$style.shopPriceText">
                  {{ labelFrom || 'from' }}
                  <IndividualPrice
                    :btype-list="product.btypeList"
                    :product-type="product.productType"
                    :value="Number(product.price)"
                  />
                </div>

                <div :class="$style.shopPriceSubline">
                  <span :class="$style.shopPriceTax">{{ product.tax + ' & ' }}</span>
                  <a :class="$style.shipping" :href="shippingURLRef">{{ product.shippingText }}</a>
                </div>
              </span>
            </a>
          </figcaption>
        </figure>
      </Slider1XP>
    </div>
  </div>
</template>

<script setup>
import Slider1XP from '../Slider1XP/Slider1XP.vue';
import IndividualPrice from '../IndividualPrice/IndividualPrice.vue';
import Badge from '../Badge/Badge.vue';

import { ref, watch } from 'vue';
import { useStoreConfiguration } from '../../store/configuration/configuration';
import { useStoreTranslations } from '../../store/translations/translations';

const configuration = useStoreConfiguration();
const translation = useStoreTranslations();

const isNewDuration = ref(0);
const storeConfig = ref(null);
const isConfigInitialized = ref(false);
const newText = ref(undefined);
const bestsellerText = ref(undefined);
const labelFrom = ref(undefined);

defineProps({
  config: {
    type: Object,
    default: () => {},
  },
});

const checkIsNew = (isNew, publicationDate) => {
  if (!isNew) {
    return false;
  }

  const msPerDay = 24 * 60 * 60 * 1000;
  const notNewAfter = publicationDate + isNewDuration.value * msPerDay;
  const rightNow = Date.now();

  return rightNow <= notNewAfter;
};

watch(
  () => configuration.config,
  (newValue) => {
    if (!newValue) {
      return;
    }

    storeConfig.value = newValue;
    isConfigInitialized.value = true;

    if (typeof newValue.ps_is_new_duration === 'number') {
      isNewDuration.value = newValue.ps_is_new_duration;
    }
  },
  { immediate: true },
);

watch(
  () => translation.translations,
  (newValue) => {
    if (newValue) {
      newText.value = newValue['productfilter.isNewText'];
      bestsellerText.value = newValue['productfilter.isBestSellerText'];
      labelFrom.value = newValue['productcode.order.from'];
    }
  },
);
</script>

<style module lang="scss">
@forward './ProductSlider.scss';
</style>
